import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Şirinevler Halı Yıkama",
    path: "/bahcelievler/sirinevler-hali-yikama",
    description:
      "Şirinevler’de halılarınız tam otomatik sistemlerde, kısa sürede hijyenik şekilde temizlenip teslim edilir."
  },
  {
    label: "Yenibosna Halı Yıkama",
    path: "/bahcelievler/yenibosna-hali-yikama",
    description:
      "Yenibosna bölgesine özel ücretsiz servisimiz ile halılarınızı adresinizden alıp özenle temizliyoruz."
  },
  {
    label: "Zafer Mahallesi Halı Yıkama",
    path: "/bahcelievler/zafer-hali-yikama",
    description:
      "Zafer Mahallesi'nde organik temizlik ürünleriyle sağlıklı ve güvenilir halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Siyavuşpaşa Halı Yıkama",
    path: "/bahcelievler/siyavuspasa-hali-yikama",
    description:
      "Siyavuşpaşa bölgesinde profesyonel ekip ve ekipmanlarla halılarınız derinlemesine temizlenir."
  },
  {
    label: "Kocasinan Halı Yıkama",
    path: "/bahcelievler/kocasinan-hali-yikama",
    description:
      "Kocasinan semtine özel hızlı teslimatlı halı yıkama hizmetimizle güvenilir temizlik garantisi sunuyoruz."
  },
  {
    label: "Fevzi Çakmak Mahallesi Halı Yıkama",
    path: "/bahcelievler/fevzi-cakmak-hali-yikama",
    description:
      "Fevzi Çakmak Mahallesi’nde halı yıkama ihtiyaçlarınız uzman kadro ve hijyen garantisiyle karşılanır."
  },
  {
    label: "Hürriyet Mahallesi Halı Yıkama",
    path: "/bahcelievler/hurriyet-hali-yikama",
    description:
      "Hürriyet Mahallesi'nde antibakteriyel temizlik ürünleriyle sağlıklı halı yıkama çözümleri sunuyoruz."
  },
  {
    label: "Soğanlı Halı Yıkama",
    path: "/bahcelievler/soganli-hali-yikama",
    description:
      "Soğanlı bölgesinde bireysel ve kurumsal müşterilere özel halı yıkama hizmeti sağlıyoruz."
  }
];

const BahcelievlerSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">BAHÇELİEVLER SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BahcelievlerSidebar;
